import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]

/**
 * IconNumber70Small
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTcwLXNtYWxsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNCAxMHY0YTIgMiAwIDEgMCA0IDB2LTRhMiAyIDAgMSAwIC00IDAiIC8+CiAgPHBhdGggZD0iTTYgOGg0bC0yIDgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/number-70-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber70Small = createReactComponent('outline', 'number-70-small', 'Number70Small', __iconNode);

export default IconNumber70Small;